import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const PressReleasesStyles = styled.div`
  padding-top: 55px;
  .press-releases-section {
    margin-bottom: 50px;
  }

  .press-releases-actions {
    display: flex;
    justify-content: center;
  }

  .press-release-filters {
    display: flex;
    flex-direction: column;

    .filter {
      display: flex;
      flex-direction: column;

      .pr-categories,
      .pr-years,
      .pr-text {
        margin-bottom: 10px;
        width: 100%;
      }
    }
  }

  .no-results {
    align-items: center;
    display: flex;
    flex-direction: column;
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .press-releases-cards {
      align-items: flex-start;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;

      .empty {
        width: calc((100% - 75px) / 4);
      }
    }

    .press-release-filters {
      flex-direction: row;
      justify-content: space-between;

      .filter {
        flex-direction: row;

        .pr-categories {
          margin-right: 25px;
          width: 200px;
        }
        .pr-years {
          width: 100px;
        }
        .pr-search {
          width: 200px;
        }
      }
    }
  }
`;

export default PressReleasesStyles;
